/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Box } from '@material-ui/core';

import styles from './styles';

import PageContainer from 'components/PageContainer';
import Title from 'components/Title';
import HorizontalRule from 'components/HorizontalRule';

import useTranslate, {
  useMarkdownTranslate,
} from 'hooks/useTranslate/useTranslate';

import { conformToMask, decimalMoneyMask } from 'utils/masks';

import BackToPrevious from 'components/unified/BackToPrevious';
import cart from 'features/unified/assets/cart.png';
import BreadIcon from '../BreadIcon';

interface InstallmentsLearnMoreViewProps {
  maxCapacity: number;
}

const InstallmentsLearnMoreView: React.FC<
  InstallmentsLearnMoreViewProps
> = props => {
  const { maxCapacity } = props;

  const t = useTranslate();
  const tMd = useMarkdownTranslate();

  return (
    <PageContainer>
      <Box mb={2}>
        <Title css={styles.pageTitleText}>
          <BreadIcon
            logo={t('unified.offer.installmentsLearnMore.breadLogo')}
            id={'installmentsBreadLogo'}
          />
          {tMd('unified.offer.installmentsLearnMore.title')}
        </Title>
      </Box>

      <Box mb={3} css={styles.subtitleText}>
        {tMd('unified.offer.installmentsLearnMore.subtitle')}
      </Box>

      <div css={styles.hrContainer}>
        <HorizontalRule />
      </div>

      <Box mb={4} css={styles.bodyContainer}>
        {tMd('unified.offer.installmentsLearnMore.body', {
          amount: conformToMask(maxCapacity.toFixed(2), decimalMoneyMask),
        })}
      </Box>

      <Box mb={4} css={styles.shadedRoundedContainer}>
        <img src={cart} alt="Checkout" css={styles.cartIcon} />
        <div>
          <div css={styles.checkoutTitle}>
            {t('unified.offer.installmentsLearnMore.checkoutTitle')}
          </div>
          {tMd('unified.offer.installmentsLearnMore.checkout')}
        </div>
      </Box>
      <BackToPrevious tMdKey="unified.offer.installmentsLearnMore.BackToPrevious" />
    </PageContainer>
  );
};

export default InstallmentsLearnMoreView;
